<template>
  <div class="cpt-chat-hover-card rounded-[8px] pointer" ref="card">
    <div class="hover-card relative wh-full overflow-hidden">
      <slot></slot>
    </div>
    <slot name="tag"></slot>
  </div>
</template>

<script>
export default {
  name: 'ChatHoverCard',
}
</script>

<style lang="scss">
.cpt-chat-hover-card {
  &:hover {
    z-index: 1;
    .hover-card {
      box-shadow: $ct-bl-2 0px 4px 4px 0px;
      transform: translate3d(0, -2px, 0);
    }
    .hover-card-bg {
      background-color: $d-op-s3!important;
    }
  }
  .hover-card {
    border-radius: inherit;
    will-change: transform;
    transition: box-shadow .2s ease-out, transform .2s ease-out, background .2s ease-out;
  }
}
</style>